<template>
  <div class="article-title-section">
    <div class="article-title-section__category">
      <span class="text">{{ content.MainType.Name + ' • ' + content.SubType.Name }}</span>
    </div>
    <div class="article-title-section__title-text">
      <h1 class="text">
        {{ content.Title }}
      </h1>
    </div>
    <div class="article-title-section__info">
      <div class="article-title-section__info__text">
        <span class="view">瀏覽數：{{ content.ViewCount }}</span>
        <span class="spacer">|</span>
        <span class="time">{{ formatCreateTime(content.CreateAt) }}</span>
      </div>
      <div class="article-title-section__info__share">
        <span class="text">分享</span>
        <a
          class="social-btn"
          @click="shareArticleByFbHandler"
        >
          <img
            src="@/assets/image/social/facebook.svg"
            alt="FB分享連結"
          >
        </a>
        <a
          class="social-btn"
          @click="shareArticleByLineHandler"
        >
          <img
            src="@/assets/image/social/line.svg"
            alt="LINE分享連結"
          >
        </a>
        <a
          class="social-btn"
          @click="copyLinkHandler"
        >
          <img
            src="@/assets/image/copyLink.png"
            alt="複製連結"
          >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {
        return {
          MainType: {
            Name: ''
          },
          SubType: {
            Name: ''
          },
          Title: '',
          ViewCount: 0
        }
      }
    }
  },
  computed: {
    routeFullPath () {
      return location.origin + this.$nuxt.$route.path
    }
  },
  async mounted () {
    try {
      await Promise.all([this.$store.dispatch('installFBSDK'), this.$store.dispatch('installLineSDK')])
      window.LineIt.loadButton()
    } catch (err) {
      console.log('err', err)
    }
  },
  methods: {
    shareArticleByFbHandler () {
      this.$gaLogEvent('文章頁', 'FB')
      window.FB.ui({
        method: 'share',
        href: this.routeFullPath
      }, function (response) {
        console.log('response', response)
      })
    },
    shareArticleByLineHandler () {
      this.$gaLogEvent('文章頁', 'Line')
      if (this.$device.isMobileOrTablet) {
        window.open(`https://line.me/R/share?text=${this.routeFullPath}`, '_blank')
      } else {
        const width = window.innerWidth * 0.5
        window.open(
          `https://social-plugins.line.me/lineit/share?url=${this.routeFullPath}`,
          'newwindow',
          `width=500,height=600,top=100,left=${width}`
        )
      }
    },
    async copyLinkHandler () {
      this.$gaLogEvent('文章頁', '複製連結')
      await this.$copyText(this.routeFullPath)
      this.$store.dispatch('toast', {
        isOpen: true,
        text: '複製成功',
        type: 'success'
      })
    },
    formatCreateTime (time) {
      return this.$dayjs(time).format('YYYY/MM/DD')
    }
  }
}
</script>

<style lang="scss">
$socialBtnHeight: 32px;
.article-title-section {
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 14px;
  &::before {
    content: "";
    background-color: $color-primary;
    position: absolute;
    top: 0;
    left: 0px;
    width: 6px;
    height: 100%;
  }
  &__category {
    margin-bottom: 4px;
    .text {
      color: $color-primary;
      font-weight: bold;
      font-size: pxTorem(15px);
    }
  }
  &__title-text {
    .text {
      font-weight: bold;
      font-size: pxTorem(21px);
      margin-bottom: 12px;
    }
  }
  &__info {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    &__text {
      .view {
        color: #4289a7;
        font-size: pxTorem(15px);
      }
      .spacer {
        margin: 0 8px;
        color: $color-border-primary;
      }
      .time {
        color: $color-caption;
        font-size: pxTorem(15px);
      }
    }
    &__share {
      display: flex;
      align-items: center;
      .text {
        margin-right: 12px;
        color: $color-caption;
        font-size: pxTorem(15px);
      }
      .social-btn {
        display: block;
        width: $socialBtnHeight;
        height: $socialBtnHeight;
        border-radius: 50%;
        margin-right: 8px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cotain;
        }
      }
    }
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .article-title-section {
    $shareBtnMarginTop: 24px;
    &::before {
      height: calc(100% - #{$socialBtnHeight} - #{$shareBtnMarginTop} + 4px);
    }
    &__info {
      flex-wrap: wrap;
      &__share {
        width: 100%;
        margin-top: $shareBtnMarginTop;
        height: 32px;
        justify-content: center;
      }
    }
  }
}
</style>
